export default "__VITE_ASSET__cb768956__"